import { NSARouterMakerResult, NSAHomePage } from "namirasoft-account-react";
import { PaymentLayout } from "../PaymentLayout";
import { PaymentProps } from "../PaymentProps";
import NSPPlanStatusList from "../components/NSPPlanStatusList";

export default function HomePage(props: NSARouterMakerResult & PaymentProps)
{
	return (
		<PaymentLayout
			{...props}
		>
			<NSAHomePage
				{...props}
				getChildren={{
					getChildrenBetween: () => (
						<NSPPlanStatusList {...props} />
					)
				}}
			/>
		</PaymentLayout>
	);
}